import { ILessonPlan, ILessonPlanData, ISession, ISessionAttendance, ISessionAttendanceData, ISessionBehaviour, ISessionBehaviourData, ISessionData, ISessionItem, ISessionParams, IShortItem, ITableRes } from 'types'
import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants'

export const sessionsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_groupCourseSessions: builder.query<ITableRes<ISessionItem>, ISessionParams>({
      query: (params) => ({
        url: '/group-course-sessions/',
        params,
      }),
      providesTags: ['group-course-sessions'],
    }),
    GET_groupCourseSessionsSelect: builder.query<any, {group: number}>({
      query: (params) => ({
        url: '/group-course-sessions/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['group-course-sessions-select'],
    }),
    GET_groupCourseSessionById: builder.query<ISession, string>({
      query: (id) => {
        return {
          url: `/group-course-sessions/${id}/`,
        }
      },
      providesTags: ['group-course-sessions'],
    }),
    GET_groupCourseSessionPrev: builder.query<ISessionItem, number>({
      query: (id) => {
        return {
          url: `/group-course-sessions/prev/${id}/`,
        }
      },
      providesTags: ['group-course-sessions'],
    }),
    GET_groupCourseSessionNext: builder.query<ISessionItem, number>({
      query: (id) => {
        return {
          url: `/group-course-sessions/next/${id}/`,
        }
      },
      providesTags: ['group-course-sessions'],
    }),
    POST_groupCourseSession: builder.mutation<ISession, ISessionData>({
      query: (body) => ({
        url: `/group-course-sessions/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['group-course-sessions','lesson-plan'],
    }),
    PATCH_groupCourseSession: builder.mutation<ISession, { id: number; body: ISessionData }>({
      query: ({ id, body }) => ({
        url: `/group-course-sessions/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['group-course-sessions','group-course-session','lesson-plan'],
    }),
    DELETE_groupCourseSession: builder.mutation<ISession, number>({
      query: (id) => ({
        url: `/group-course-sessions/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['group-course-sessions','lesson-plan'],
    }),
    GET_groupCourseSessionSelect: builder.query<any, {group_course: number}>({
      query: (params) => ({
        url: '/group-course-sessions/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['group-course-sessions-select'],
    }),
    GET_groupCourseSessionAttendance: builder.query<ITableRes<ISessionAttendance>, number>({
      query: (id) => {
        return {
          url: `/group-course-sessions/${id}/attendance/`,
        }
      },
      transformResponse: (response: any): any => {
        return {
         ...response,
         results: response.results.map(item => {
          return {
            ...item,
            status: {id: item.status, title: item.status}
          }
         })
        }
      },
      providesTags: ['group-course-session-attendance', 'attendance'],
    }),
    POST_groupCourseSessionAttendance: builder.mutation<ITableRes<ISessionAttendance>, {id: number; body: ISessionAttendanceData[]}>({
      query: ({id, body}) => ({
        url: `/group-course-sessions/${id}/attendance/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['group-course-session-attendance','group-course-session', 'attendance'],
    }),
    GET_groupCourseSessionBehaviour: builder.query<ITableRes<ISessionBehaviour>, number>({
      query: (id) => {
        return {
          url: `/group-course-sessions/${id}/behaviour-incidents/`,
        }
      },
      providesTags: ['group-course-session-behaviour-incidents', 'behavior'],
    }),
    POST_groupCourseSessionBehaviour: builder.mutation<ITableRes<ISessionBehaviour>, {id: number; body: ISessionBehaviourData[]}>({
      query: ({id, body}) => ({
        url: `/group-course-sessions/${id}/behaviour-incidents/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['group-course-session-behaviour-incidents','group-course-session', 'behavior'],
    }),
  }),
})

export const { 
  useGET_groupCourseSessionsQuery, 
  useGET_groupCourseSessionsSelectQuery,
  useGET_groupCourseSessionByIdQuery,
  useGET_groupCourseSessionPrevQuery,
  useGET_groupCourseSessionNextQuery,
  usePOST_groupCourseSessionMutation,
  usePATCH_groupCourseSessionMutation,
  useDELETE_groupCourseSessionMutation,
  useGET_groupCourseSessionAttendanceQuery,
  usePOST_groupCourseSessionAttendanceMutation,
  useGET_groupCourseSessionBehaviourQuery,
  usePOST_groupCourseSessionBehaviourMutation,
  useGET_groupCourseSessionSelectQuery,
} = sessionsAPI
